/**
 * Add a :icontains selector to jQuery to allow case-insensitive
 * :contains selection.
 */
jQuery.expr.pseudos.icontains = jQuery.expr.createPseudo(function (arg) {
  return function (elem) {
    // Match any text followed by any spaces/newlines followed by
    // a number in parentheses, with an optional comma to separate
    // the thousands digits
    // ex: Apparel (1,234)
    let regex = /(.+)[\s\S]+\([\d,]+\)/;
    let text = (elem.textContent || '').trim();
    let matches = text.match(regex);
    if (matches === null) {
      return false;
    }

    // Match the facet text (without facet counts) against the search term
    return matches[1].toUpperCase().indexOf(arg.toUpperCase()) >= 0;
  };
});

/**
 * jQuery plugin to handle facet filtering.
 */
$.fn.facetSearch = function (options) {
  return this.each(function (index, element) {
    let settings = $.extend({
      keyPressTimer: undefined,
      formId: $(element).data('facetFormId')
    }, options);
    $(element).on('keyup', () => {
      clearTimeout(settings.keyPressTimer);
      settings.keyPressTimer = setTimeout(function () {
        let formId = settings.formId;
        if (!formId.startsWith('#')) {
          formId = '#' + formId;
        }
        let $facetList = $(formId).find('ul');
        $facetList.find('li.no-facets').remove();
        $facetList.children('.facets__addtl-link').hide();
        let searchTerm = element.value;
        if (!searchTerm) {
          let $topLevelFacets = $(formId).find('> .facets-list > li');
          if ($topLevelFacets.length === 1) {
            // Open parent if there is only one facet is available
            $topLevelFacets.find('>.facets__title').trigger('facet-open');
            let $childFacetList = $topLevelFacets.find('>.facets__subchild >.facets-list >li');
            if ($childFacetList.length === 1) {
              // Open child if there is only one child available
              $childFacetList.find('li').show().end().find('>.facets__title').trigger('facet-open');
            } else {
              // Collapse children if there are more than one
              $childFacetList.find('>.facets__title').trigger('facet-close').end().show().end();
            }
            $facetList.find('li').removeAttr('style');
          } else {
            // The search term filter was removed. Show all of
            // the facets and collapse any expanded facet trees.
            $facetList.find('li').show().end().find('.facets__children:not(.facets-list__link--selected)').trigger('facet-close');
            $facetList.find('li').removeAttr('style');
            DK.Search.Seo.hideLongLists();
          }
          return;
        }
        $facetList.find(`li:not(:icontains("${searchTerm}"))`).hide().end().find(`li:icontains("${searchTerm}")`).show().parentsUntil('form').show();
        let visible = $facetList.find('li:visible').length;
        if (visible === 0) {
          // No facets matched the search term. Display a message
          // to the user.
          $facetList.prepend('<li class="no-facets">No results found.</li>');
        } else {
          // Some facets matched the search term. Expand the
          // facet trees to make sure all of the matching
          // children are displayed.
          $facetList.find('.icon').trigger('facet-open');
        }
      }, 200);
    });
  });
};